import { themeFn } from './theme';
export var corners = {
  s: '2px',
  m: '4px',
  l: '6px'
}; // eslint-disable-next-line no-underscore-dangle

export var sizes = {
  xxs: themeFn(function (props) {
    return props.sizes.xxs;
  }),
  xs: themeFn(function (props) {
    return props.sizes.xs;
  }),
  s: themeFn(function (props) {
    return props.sizes.s;
  }),
  m: themeFn(function (props) {
    return props.sizes.m;
  }),
  l: themeFn(function (props) {
    return props.sizes.l;
  }),
  xl: themeFn(function (props) {
    return props.sizes.xl;
  }),
  xxl: themeFn(function (props) {
    return props.sizes.xxl;
  }),
  xxxl: themeFn(function (props) {
    return props.sizes.xxxl;
  })
};